import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { UserCircleIcon } from '@ergeon/icons/hero/outline';

export const NoCustomersEmptyState = () => (
  <div className="flex flex-col justify-center items-center p-6 pb-12 h-full">
    <EmptyState description="Try adjusting your search query." icon={<UserCircleIcon />} title="No customers" />
  </div>
);
